import React, { useMemo, useCallback, useState } from 'react';
import { useAuth } from '../../../contexts/auth';
import List, { ListTypes } from 'devextreme-react/list';
import Popup from 'devextreme-react/popup';
import Form, { Item, ButtonItem } from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import axios from 'axios';
import './UserMenuSection.scss';
import type { UserMenuSectionProps } from '../../../types';
import { nameserver } from '../../../config/nameServer';
type MenuItem = {
  text: string;
  icon: string;
  onClick: () => void;
};

export const UserMenuSection = ({
  showAvatar,
  listRef,
}: UserMenuSectionProps) => {
  const { user, signOut } = useAuth();
  const [popupVisible, setPopupVisible] = useState(false);

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const menuItems = useMemo<MenuItem[]>(
    () => [
      {
        text: 'Đổi mật khẩu',
        icon: 'key',
        onClick: () => setPopupVisible(true),
      },
      {
        text: 'Thoát',
        icon: 'runner',
        onClick: signOut,
      },
    ],
    []
  );
  const changePassword = async () => {
    if (formData.newPassword !== formData.confirmPassword) {
      notify('Mật khẩu không khớp', 'error', 2000);
      return;
    }

    const userId = localStorage.getItem('userId');

    try {
      const payload = {
        userId: Number(userId),
        oldPassword: formData.oldPassword,
        newPassword: formData.newPassword,
      };

      await axios.post(`${nameserver}/api/change-password`, payload);

      notify('Đổi mật khẩu thành công', 'success', 2000);

      // 🔥 Quan trọng
      signOut();
    } catch (err: any) {
      notify(
        err.response?.data?.message || 'Đổi mật khẩu thất bại',
        'error',
        2000
      );
    }
  };
  const listElementAttr = {
    class: 'user-info-list',
  };

  const onItemClick = useCallback(
    ({ itemData }: ListTypes.ItemClickEvent<MenuItem>) => itemData?.onClick(),
    []
  );

  return (
    <>
      <div className='user-info'>
        {showAvatar && (
          <div className='image-container'>
            <div
              style={
                {
                  // backgroundImage: `url(${user?.avatarUrl})`,
                }
              }
              className='user-image'
            />
          </div>
        )}
        {/* <div className='user-name'>{user?.name}</div> */}
      </div>
      <List
        ref={listRef}
        elementAttr={listElementAttr}
        onItemClick={onItemClick}
        items={menuItems}
      />
      <Popup
        visible={popupVisible}
        title='Đổi mật khẩu'
        width={400}
        height={300}
        onHiding={() => setPopupVisible(false)}
      >
        <Form formData={formData}>
          <Item
            dataField='oldPassword'
            label={{ text: 'Mật khẩu cũ' }}
            editorOptions={{ mode: 'password' }}
          />
          <Item
            dataField='newPassword'
            label={{ text: 'Mật khẩu mới' }}
            editorOptions={{ mode: 'password' }}
          />
          <Item
            dataField='confirmPassword'
            label={{ text: 'Nhập lại mật khẩu' }}
            editorOptions={{ mode: 'password' }}
          />
          <Item
            render={() => (
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={changePassword}>Lưu</button>
                <button onClick={() => setPopupVisible(false)}>Hủy</button>
              </div>
            )}
          />
        </Form>
      </Popup>
    </>
  );
};
